<form [formGroup]="contactForm" class="contact-form">
  <!-- Recipient Type -->
  <div class="form-field-wrapper">
    <label class="custom-label">{{ 'TASK.CONTACT.CONTACT_TYPE' | translate }}</label>
    <mat-form-field appearance="outline" class="custom-mat-field">
      <mat-select formControlName="contactType" [placeholder]="'TASK.CONTACT.SELECT_TYPE' | translate">
        <mat-option *ngFor="let type of contactTypes" [value]="type">
          {{type.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Contact -->
  <div class="form-field-wrapper">
    <label class="custom-label" [class.disabled]="isContactDisabled">{{ 'TASK.CONTACT.CONTACT' | translate }}</label>
    <mat-form-field appearance="outline" class="custom-mat-field contact-field" [class.field-disabled]="isContactDisabled">
      <mat-icon matPrefix class="search-icon">search</mat-icon>
      <input
        matInput
        formControlName="contact"
        #contactInput="matAutocompleteTrigger"
        [matAutocomplete]="auto"
        [placeholder]="'TASK.CONTACT.SELECT_CONTACT' | translate">

      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayContact"
        class="contact-autocomplete">

        <!-- New Contact -->
        <mat-option *ngIf="canCreateContact" class="add-new-option" (onSelectionChange)="openNewContactFromSelect($event)">
        <mat-icon class="add-icon">add</mat-icon>
          <span>{{ 'TASK.CONTACT.NEW_CONTACT' | translate }}</span>
        </mat-option>

        <mat-divider *ngIf="canCreateContact"></mat-divider>

        <!-- Contact List -->
        <mat-option
          *ngFor="let contact of filteredContacts$ | async"
          [value]="contact"
          class="contact-option">
          <div class="contact-info">
            <div class="contact-name">{{ displayContact(contact) }}</div>
            <div class="contact-address">{{ getAddressLabel(contact.cdx_datas) }}</div>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="form-actions">
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="!isFormValid"
      (click)="onSave()">
      {{ 'TASK.CONTACT.VALIDATE' | translate }}
    </button>
  </div>
</form>
